var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { applyPatch } from 'fast-json-patch';
import { Subject } from 'rxjs';
import { filter, map, switchAll } from 'rxjs/operators';
import { CancelSubscriptionRequest, isHighLevelResponse, isHighLevelUpdate } from '../../message';
import { SubscriptionModule } from '../SubscriptionModule';
var EndpointHandler = (function () {
    function EndpointHandler(client, subjectManager) {
        var _this = this;
        this.resultMapper = map(function (response) {
            if (isHighLevelUpdate(response)) {
                var patchedResponse = _this.applyEndpointJsonPatchUpdate(response.jobId, response.data);
                return { response: patchedResponse, data: patchedResponse.data };
            }
            return { response: response, data: response.data };
        });
        this.requestToJobMapper = new Map();
        this.client = client;
        this.subjectManager = subjectManager;
        this.responses = {};
        this.logger = this.client.getLogger();
    }
    EndpointHandler.prototype.observe = function (method, path, data, options) {
        var _this = this;
        this.validateOptions(options);
        var subject = new Subject();
        var mainSubject = new Subject();
        var mainObservable = mainSubject.pipe(switchAll());
        var observable = subject.asObservable()
            .pipe(EndpointHandler.responseFilter, this.resultMapper.bind(this));
        this.client.requestEndpoint(method, path, data, { subscribe: true })
            .then(function (result) {
            _this.subjectManager.registerJobSubject(result.response.jobId, subject);
            _this.registerEndpointRequest(result.response.jobId, mainSubject, mainObservable, method, path, data, options);
            _this.registerEndpointResponse(result.response.jobId, result.response);
            observable.idJob = result.response.jobId;
            mainSubject.next(observable);
            mainObservable.idJob = result.response.jobId;
            subject.next(result.response);
        })
            .catch(function (err) { return _this.logger.warn('Request failed during initial request for observe endpoint', err); });
        return mainObservable;
    };
    EndpointHandler.prototype.unobserve = function (idJob) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.subjectManager.hasJobSubject(idJob)) {
                            this.logger.warn("Could not find subscription for idJob \"" + idJob + "\".");
                            return [2];
                        }
                        return [4, this.client.request(new CancelSubscriptionRequest(idJob))];
                    case 1:
                        _a.sent();
                        this.requestToJobMapper.delete(idJob.toString());
                        this.subjectManager.removeJobSubject(idJob);
                        return [2];
                }
            });
        });
    };
    EndpointHandler.prototype.findSubject = function (idJob) {
        return this.subjectManager.getJobSubject(idJob);
    };
    EndpointHandler.prototype.registerEndpointResponse = function (idJob, response) {
        this.responses[idJob] = response;
    };
    EndpointHandler.prototype.registerEndpointRequest = function (idJob, subject, observable, method, path, data, options) {
        this.requestToJobMapper.set(idJob.toString(), { path: path, subject: subject, observable: observable, data: data, method: method, options: options });
    };
    EndpointHandler.prototype.applyEndpointJsonPatchUpdate = function (idJob, patch) {
        var response = this.responses[idJob];
        var result = applyPatch(response, patch).newDocument;
        this.responses[idJob] = result;
        return result;
    };
    EndpointHandler.prototype.restartSubscriptions = function () {
        var _this = this;
        var oldSubscriptions = Array.from(this.subjectManager.jobs.keys());
        var oldRequests = new Map(this.requestToJobMapper);
        this.requestToJobMapper.clear();
        this.subjectManager.jobs.clear();
        oldSubscriptions.forEach(function (idJob) {
            var request = oldRequests.get(idJob);
            if (request) {
                _this.validateOptions(request.options);
                var subject_1 = new Subject();
                var observable_1 = subject_1.asObservable()
                    .pipe(EndpointHandler.responseFilter, _this.resultMapper.bind(_this));
                _this.client.requestEndpoint(request.method, request.path, request.data, { subscribe: true })
                    .then(function (result) {
                    _this.subjectManager.registerJobSubject(result.response.jobId, subject_1);
                    _this.registerEndpointResponse(result.response.jobId, result.response);
                    request.observable.idJob = result.response.jobId;
                    request.subject.next(observable_1);
                    subject_1.next(result.response);
                    _this.registerEndpointRequest(result.response.jobId, request.subject, request.observable, request.method, request.path, request.data, request.options);
                })
                    .catch(function (err) { return _this.logger.warn('Request failed during initial request for restarting endpoint subscription', err); });
            }
        });
    };
    EndpointHandler.prototype.validateOptions = function (options) {
        var opts = Object.assign({}, SubscriptionModule.defaultObserveOptions, options);
        if (opts && opts.minInterval) {
            this.logger.warn('Option `minInterval` is deprecated. ' +
                'Use _subscriptionMinimumInterval (GET) or meta.subscription.minimumInterval (POST) for server side throttling.');
        }
    };
    EndpointHandler.responseFilter = filter(function (response) { return isHighLevelResponse(response) || isHighLevelUpdate(response); });
    return EndpointHandler;
}());
export { EndpointHandler };
//# sourceMappingURL=EndpointHandler.js.map